/**
 * @generated SignedSource<<9920d80ed3ffb8296f4177e35c9767bf>>
 * @relayHash fbfc8b8d812ec57869efd1d1a8f96b64
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9c3b957a7acb0f3b2400a3c8d63bd515436b35fe4fea14eb3b4a968f58d9e8d0

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { BusinessSummarySpaAppsQuery } from './BusinessSummarySpaAppsQuery.graphql';

const node: PreloadableConcreteRequest<BusinessSummarySpaAppsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "9c3b957a7acb0f3b2400a3c8d63bd515436b35fe4fea14eb3b4a968f58d9e8d0",
    "metadata": {},
    "name": "BusinessSummarySpaAppsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
